import { FormMessage } from './form-message';
import { TransitionMessage } from './form-transition';
import { AsdBase } from '../../asd/asd';

export class FormInterfaceCommunicatorProperty {
  constructor(TransitStateID: string, Message: FormMessage, Options, UserActionID: string, ProcessRequiredOnServer: boolean, OldStateID: string) {
    this.message = Message;
    this.options = Options;
    this.TransitStateID = TransitStateID;
    this.userActionID = UserActionID;
    this.ProcessRequiredOnServer = ProcessRequiredOnServer;
    this.OldStateID = OldStateID;
  }

  OldStateID: string;
  TransitStateID: string;
  message: FormMessage;
  userActionID: string;
  ClickedUAInterfaceElementID: string;
  ProcessRequiredOnServer: boolean;
  UXControlInterfaceElementID: string;

  options: [
    {
      option: any;
      transitUserActionID: string;
      actionProcessOnServer: boolean;
    }
  ];
}
